import AstronautIcon from '@/assets/images/app-icons/astronaut.png';
import BlueIcon from '@/assets/images/app-icons/blue.png';
import DarkIcon from '@/assets/images/app-icons/dark.png';
import EditorialIcon from '@/assets/images/app-icons/editorial.png';
import OriginalIcon from '@/assets/images/app-icons/original.png';
import PersonIcon from '@/assets/images/app-icons/person.png';
import PixelIcon from '@/assets/images/app-icons/pixel.png';
import SkyIcon from '@/assets/images/app-icons/sky.png';
import YellowIcon from '@/assets/images/app-icons/yellow.png';
import { subscriptionStore } from '@/features/subscription/subscription.store';
import { userStore } from '@/stores/user.store';

import type { AppIconChoice } from '@electron/shared/app-icon-choice.types';

type AppIconChoiceDetails = {
  label: string;
  preview: string;
  requiresPaidPlan: boolean;
};

export const APP_ICON_CHOICE_DETAILS: Record<
  AppIconChoice,
  AppIconChoiceDetails
> = {
  original: {
    label: 'Classic',
    preview: OriginalIcon,
    requiresPaidPlan: false,
  },
  blue: { label: 'Blue', preview: BlueIcon, requiresPaidPlan: false },
  yellow: { label: 'Sunshine', preview: YellowIcon, requiresPaidPlan: false },
  dark: { label: 'Midnight', preview: DarkIcon, requiresPaidPlan: false },
  sky: { label: 'Sky', preview: SkyIcon, requiresPaidPlan: true },
  astronaut: { label: 'Orbit', preview: AstronautIcon, requiresPaidPlan: true },
  person: { label: 'Daydream', preview: PersonIcon, requiresPaidPlan: true },
  pixel: { label: 'Pixel', preview: PixelIcon, requiresPaidPlan: true },
  editorial: {
    label: 'Editorial',
    preview: EditorialIcon,
    requiresPaidPlan: true,
  },
};

type AppIconChoiceAccess = 'open' | 'locked' | 'pending';

export const appIconChoiceAccess = (
  icon: AppIconChoice
): AppIconChoiceAccess => {
  const hasPaidAccess = subscriptionStore.isPlus || userStore.hasInternalAccess;
  if (!APP_ICON_CHOICE_DETAILS[icon].requiresPaidPlan || hasPaidAccess) {
    return 'open';
  }
  return subscriptionStore.state.isLoading ? 'pending' : 'locked';
};
